import { Component, EventEmitter, Input, Output } from '@angular/core';
import { PrivacyItem, PrivacyItemOption, PrivacyItemOptionToPass } from '../../core/types/privacy-item.type';
import { FormGroup, ReactiveFormsModule } from '@angular/forms';
import { CommonModule } from '@angular/common';


@Component({
  selector: 'app-info-confirmation-box',
  templateUrl: './info-confirmation-box.component.html',
  styleUrls: ['./info-confirmation-box.component.css'],
  imports: [ReactiveFormsModule, CommonModule],
  standalone: true,
})
export class InfoConfirmationBoxComponent   {
  @Input() propertyId!: number;
  @Input() id!: number;
  @Input() privacyItem!: PrivacyItem;
  @Input() form!: FormGroup;
  @Input() isForPdf = false;
  @Input() privacyItemIndex!: number;
  @Output() isSelected = new EventEmitter<{isSelected: boolean; id: number; option: PrivacyItemOptionToPass }>();
  isCollapsed = false;
  selectedValues: { optionId: number; optionValue: string }[] = [];


  checkIfSelected(option: PrivacyItemOption) {
    return this.selectedValues.some((value) => value.optionId === option.id && value.optionValue === option.value);
  }

  onChangeControl(event: Event, privacyItem: PrivacyItem, option: PrivacyItemOption,
  ): void {
    let value;
    if (privacyItem.type === 'checkbox' && privacyItem.options?.length === 1) {
      value = JSON.stringify((event.target as HTMLInputElement)?.checked && option.value === 'true');
    } else {
      value = option.value;
    }
    let privacyItemsControlValues = this.form.get('acceptedPrivacyItems')?.value;
    privacyItemsControlValues = [
      ...privacyItemsControlValues.filter((option: { propertyId: number }) => option.propertyId !== this.propertyId),
    ];
    const optionToPass: PrivacyItemOptionToPass = {
      type: privacyItem.type,
      privacyItemId: privacyItem.id,
      propertyId: this.propertyId,
      id: option.id,
      value: value,
      label: option.label,
      required: option.required,
      isSelected: true
    };
    this.selectedValues.push({ optionId: option.id, optionValue: value });
    privacyItemsControlValues.push(option);
    this.isSelected.emit({isSelected: (event.target as HTMLInputElement)?.checked, id: this.id, option: optionToPass });
  }
}
